export var Constants;
(function (Constants) {
    Constants["DOUBLE_BARS"] = "||";
    Constants["SLASH"] = "/";
    Constants["FIRST"] = "first";
    Constants["SECOND"] = "second";
    Constants["THIRD"] = "third";
    Constants["SPACE"] = " ";
    Constants["SEMICOLON"] = ",";
    Constants["BEARER"] = "BEARER";
    Constants["FALLBACK_LANG"] = ":FALLBACK:";
})(Constants || (Constants = {}));
